import React from 'react';
import Icon from '@/components/icon/Icon';
import { IconsDictionary } from '@/components/icon/Icon.types';
import ErrorMessageStyled from './ErrorMessage.styled';

interface Props {
  className?: string;
  message: string | null | undefined;
}

const ErrorMessage = ({ className, message }: Props) => {
  if (!message) return null;
  return (
    <ErrorMessageStyled className={className}>
      <Icon icon={IconsDictionary.Warning} />
      <span>{message}</span>
    </ErrorMessageStyled>
  );
};

export default ErrorMessage;
